import SummaryInterface from '@/utilities/bid/interfaces/SummaryInterface'

class SummaryClientTable {
  summaryArray: Array<SummaryInterface>

  constructor(summaryArray: Array<SummaryInterface>) {
    this.summaryArray = summaryArray
  }

  payload(bidNumber: string) {
    let item = { companyName: '', customerName: '' }
    if (this.summaryArray.length) {
      item = this.summaryArray.find(element => element.bidNumber === bidNumber) ?? { companyName: '', customerName: '' }
    }
    return [
      { title: 'Client Name', key: 'client', value: item.customerName },
      { title: 'Company Name', key: 'company', value: item.companyName },
    ]
  }

  siteCard(bidNumber: string) {
    let item = { bidNumber: '', surveyName: '' }
    if (this.summaryArray.length) {
      item = this.summaryArray.find(element => element.bidNumber === bidNumber) ?? { bidNumber: '', surveyName: '' }
    }
    return [
      { title: 'Bid Id', key: 'bidNumber', value: item.bidNumber },
      { title: 'Bid Name', key: 'bidName', value: item.surveyName },
    ]
  }

  specification(bidNumber: string): { client: string; company: string; manager: string; survey: string; bid: string } {
    let item = { companyName: '', customerName: '', salesManager: '', surveyName: '', bidNumber: '' }
    if (this.summaryArray.length) {
      item = this.summaryArray.find(element => element.bidNumber === bidNumber) ?? {
        companyName: '',
        customerName: '',
        salesManager: '',
        surveyName: '',
        bidNumber: '',
      }
    }
    return {
      client: item.customerName,
      company: item.companyName,
      manager: item.salesManager,
      survey: item.surveyName,
      bid: item.bidNumber,
    }
  }
}

export default SummaryClientTable
